import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import PaycodeHeader from '../containers/codes/PaycodeHeader';
import PaycodeList from '../containers/codes/PaycodeList';


export default (children = null) => {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <PaycodeHeader />
          <PageContentWrapper>
            <PaycodeList />
          </PageContentWrapper>
        </PageContent>
        {children}
      </PageWrapper>
    </React.Fragment>
  );
};
